import type { PostalCode } from "../constants";

export const canadianPostalCodeRegex =
  /^(?:(?:[ABCEGHJKLMNPRSTVXY][0-9][A-Z] ?[0-9][A-Z][0-9]))$/i;

export const isCanadianPostalCode = (postalCode: PostalCode) => {
  return canadianPostalCodeRegex.test(postalCode ?? "");
};
